import * as React from 'react';
import LoadingIcon from './LoadingIcon';
import TextTransition from './TextTransition';

export default function LoadingMorph() {
  return (
    <>
      <div className="tw-flex tw-h-[350px]">
        <div className="tw-m-auto">
          <LoadingIcon />
        </div>
      </div>
      <TextTransition />
    </>
  );
}
